import React, { FC, useState, useEffect, createContext, useRef } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { Space, Table, Popover, Typography } from 'antd'
import type { PaginationProps } from 'antd'
import type { IColProperty } from '@/pages/table2SearchAll'
import { IPagination } from '@/store/models/tableEdit.model'
import {
    IssuesCloseOutlined, StrikethroughOutlined, BankOutlined
} from '@ant-design/icons'
import { useTranslation } from 'react-i18next'
import moment from 'moment'
import type { IAppState } from '@/store/reducers'
import { getStatusList } from '@/services/table.service'
import { getErrorStr } from '@/store/sagas/table.saga'
import { requestFail } from '@/store/actions/common.action'
import PageBreadcrumb from '@/components/pageBreadcrumb'
import Nav from '@/components/nav'

type EditableTableProps = Parameters<typeof Table>[0]
type ColumnTypes = Exclude<EditableTableProps['columns'], undefined>

export const DrawerShowContext = createContext<{
    showSearchPop: boolean
    setShowSearchPop: any
    classArr: any[]
    getList: any
}>({
    showSearchPop: false,
    setShowSearchPop: null,
    classArr: [],
    getList: null
})

const TechChangeList: FC = () => {
    const dispatch = useDispatch()
    const { t, i18n } = useTranslation()
    const { Text } = Typography
    const history: any = useHistory()
    const route = useSelector((state: IAppState) => state.router)
    // const authInfo = useSelector((state: IAppState) => state.auth.authInfo)

    const [loading, setLoading] = useState(true)
    const [dataSource, setDataSource] = useState([])
    const [winW, setWinW] = useState(0)
    const [winH, setWinH] = useState(0)
    const [paginationInfo, setPaginationInfo] = useState<IPagination>({
        pageIndex: 1,
        pageSize: 10,
        total: 0
    })
    // pageSize 变更后，会重复触发 pageChange 事件
    const pageSizeChanged = useRef<boolean>(false)

    const viewStatus = (text: string, record: any) => (<Space>
        {/* 上传技术定义书 （作为新增） */}
        {record.auditStatus != null && record.approvalStatus == null  && <Text className='txt_red hand' 
        >{[t('planauditWait'), t('planauditPass'), t('planauditUnPass')][record.auditStatus - 1] }</Text>}

        {/* 结项评审 [t('Wait Approval'), t('Already Approval'), t('jxauditWait'), t('jxauditPass'), t('jxauditUnPass')][text - 1] */}
        {record.auditStatus == 2 && record.approvalStatus != null  && <Text className='txt_red hand' 
        >{[t('Wait Approval'), t('Already Approval'), t('jxauditWait'), t('jxauditPass'), t('jxauditUnPass')][record.approvalStatus - 1]} </Text>}
    </Space>)

    const viewButton = (text: string, record: any) => (<Space>
        {/* 上传技术定义书 （作为新增） */}

        {/* 审核技术定义书 */}
        {record.auditStatus === 1 && !record.taskStatus && <Text className='txt_blue hand' title={t('Approval Tech Definition')}
            onClick={() => {
                history.push(`/techChangeStatus?id=${record.id}&mode=audit`)
            }}
        ><IssuesCloseOutlined style={{ fontSize: 16 }} /></Text>}
        {/*         
        {record.auditStatus === 2 && !record.taskStatus && <Text className='txt_blue hand' title={t('Upload Task')}
            onClick={() => {
                history.push(`/techChangeStatus?id=${record.id}&mode=addtask`)
            }}
        ><DotChartOutlined style={{ fontSize: 16 }} /></Text>}
        {record.taskStatus === 1 && <Text className='txt_blue hand' title={t('Audit Task')}
            onClick={() => {
                history.push(`/techChangeStatus?id=${record.id}&mode=audittask`)
            }}
        ><RadarChartOutlined style={{ fontSize: 16 }} /></Text>} 
        */}

        {/* 添加课题关联项目 */}
        {(record.auditStatus === 2)
            && (!record.approvalStatus || record.approvalStatus != 1 )
            && <Text className='txt_blue hand' title={t('Tech Relative Project')}
                onClick={() => {
                    history.push(`/techChangeStatus?id=${record.id}&mode=addrelative`)
                }}
            ><StrikethroughOutlined style={{ fontSize: 16 }} /></Text>
        }
        {/* 结项评审 */}
        {record.approvalStatus === 3 && <Text className='txt_blue hand' title={t('Finish Approval') + (i18n.language !== 'zh' ? ' ' : '') + t('audit')}
            onClick={() => {
                history.push(`/techChangeStatus?id=${record.id}&mode=auditrelative`)
            }}
        ><BankOutlined style={{ fontSize: 16 }} /></Text>}
    </Space>)
    const columns: (ColumnTypes[number] & IColProperty)[] = [
        {
            title: () => <span>{t('Work Group')}</span>,
            dataIndex: ['techProject', 'techClass', 'workGroup', 'workGroupName'],
            key: 'workGroupName',
            width: 150,
            fixed:true,
            ellipsis: { showTitle: true }
        },
        {
            title: () => <span>{t('Classification')}</span>,
            dataIndex: ['techProject', 'techClass', 'classificationName'],
            key: 'Classification',
            width: 150,
            fixed:true,
            ellipsis: { showTitle: true }
        },
        {
            title: () => <span>{t('Tech Name')}</span>,
            dataIndex: ['techProject', 'techName'],
            key: 'techName',
            width: 150,
            fixed:true,
            ellipsis: { showTitle: true },
            render (text: string) {
                return (<Popover 
                    title=""
                    content={
                        <div dangerouslySetInnerHTML={{
                            __html: (text.includes('"str":') && text.includes('"obj":')) ? (JSON.parse(text).str) : `<span>${text}</span>`
                        }}></div>
                    }
                >
                    <div dangerouslySetInnerHTML={{
                        __html: (text.includes('"str":') && text.includes('"obj":')) ? (JSON.parse(text).str) : `<span>${text}</span>`
                    }}></div>
                </Popover>)
            }
        },
        {
            title: () => <span>{t('PTN')}</span>,
            dataIndex: ['techProject', 'techPtn'],
            key: 'techPtn',
            width: 150,
            ellipsis: { showTitle: true }
        },
        {
            title: () => <span>{t('creator')}</span>,
            dataIndex: ['creator'],
            key: 'creator',
            width: 200,
            ellipsis: { showTitle: true }
        },
        {
            title: () => <span>{t('createTime')}</span>,
            dataIndex: 'createTime',
            key: 'createTime',
            width: 180,
            ellipsis: { showTitle: true },
            // 1 待审核，2 审核通过，3 审核不通过
            render (text: Date) {
                return moment(text).format('YYYY-MM-DD HH:mm:ss')
            }
        },
        {
            title: () => <span>{t('auditor')}</span>,
            dataIndex: ['auditor'],
            key: 'auditor',
            width: 200,
            ellipsis: { showTitle: true }
        },
        {
            title: () => <span>{t('auditTime')}</span>,
            dataIndex: 'auditTime',
            key: 'auditTime',
            width: 180,
            ellipsis: { showTitle: true },
            render (text: Date) {
                return text ? moment(text).format('YYYY-MM-DD HH:mm:ss') : ''
            }
        },
        // {
        //     title: () => <span>{t('Tech Definition') + t('auditStatus')}</span>,
        //     dataIndex: 'auditStatus',
        //     key: 'auditStatus',
        //     width: 150,
        //     ellipsis: { showTitle: true },
        //     // 1 待审核，2 审核通过，3 审核不通过
        //     render (text: 1 | 2 | 3) {
        //         return text === 1 ? t('auditWait') : (text === 2 ? t('auditPass') : t('auditUnPass'))
        //     }
        // },
        {
            title: () => <span>{ t('auditComments')}</span>,
            dataIndex: 'auditComments',
            key: 'auditComments',
            width: 250,
            ellipsis: { showTitle: true },
            render(text: string) {
                return <Popover 
                    title=""
                    content={
                        <b>{text}</b>
                    }
                >
                    <div className='table_ellipsis' style={{ maxWidth: 230 }}>
                        <Text style={{ whiteSpace: 'pre-wrap' }}>{text}</Text>
                    </div>
                </Popover>
            }
        },
        // {
        //     title: () => <span>{t('Task Book') + t('auditStatus')}</span>,
        //     dataIndex: 'taskStatus',
        //     key: 'taskStatus',
        //     width: 150,
        //     ellipsis: { showTitle: true },
        //     // 1 待审核，2 审核通过，3 审核不通过
        //     render (text: 1 | 2 | 3) {
        //         return [t('taskauditWait'), t('taskauditPass'), t('taskauditUnPass')][text - 1]
        //     }
        // },
        // {
        //     title: () => <span>{t('Task Book') + t('auditComments')}</span>,
        //     dataIndex: 'taskComments',
        //     key: 'taskComments',
        //     width: 250,
        //     ellipsis: { showTitle: true },
        //     render(text: string) {
        //         return <Popover 
        //             title=""
        //             content={
        //                 <b>{text}</b>
        //             }
        //         >
        //             <div className='table_ellipsis' style={{ maxWidth: 230 }}>
        //                 <Text style={{ whiteSpace: 'pre-wrap' }}>{text}</Text>
        //             </div>
        //         </Popover>
        //     }
        // },
        // {
        //     title: () => <span>{t('Tech Status')}</span>,
        //     dataIndex: 'approvalStatus',
        //     key: 'approvalStatus',
        //     width: 150,
        //     ellipsis: { showTitle: true },
        //     // 1待立项，2已立项，3结项待评审，4结项评审通过，5结项评审不通过
        //     render (text: number) {
        //         return [t('Wait Approval'), t('Already Approval'), t('jxauditWait'), t('jxauditPass'), t('jxauditUnPass')][text - 1]
        //     }
        // },
        {
            title: () => <span>{t('Tech Approval Comment')}</span>,
            dataIndex: 'approvalComments',
            key: 'approvalComments',
            width: 250,
            ellipsis: { showTitle: true },
            render(text: string) {
                return <Popover 
                    title=""
                    content={
                        <b>{text}</b>
                    }
                >
                    <div className='table_ellipsis' style={{ maxWidth: 230 }}>
                        <Text style={{ whiteSpace: 'pre-wrap' }}>{text}</Text>
                    </div>
                </Popover>
            }
        },
        {
            title: () => <span>{t('auditStatus')}</span>,
            dataIndex: 'status',
            key: 'status',
            width: 150,
            fixed: 'right',
            render: viewStatus
        },
        {
            title: () => <span>{t('Action')}</span>,
            dataIndex: 'operation',
            key: 'operation',
            width: 150,
            fixed: 'right',
            render: viewButton
        }
    ]
    const getList = async (params: any) => {
        try {
            setLoading(true)
            const res = await getStatusList({
                ...params,
                pageNo: params ? params.pageIndex : paginationInfo.pageIndex,
                pageSize: params ? params.pageSize : paginationInfo.pageSize,
            }).finally(() => {
                setLoading(false)
            })
            setDataSource(res.content)
            setPaginationInfo({
                pageIndex: params ? params.pageIndex : paginationInfo.pageIndex,
                pageSize: params ? params.pageSize : paginationInfo.pageSize,
                total: res.totalElements
            })
        } catch (error: any) {
            const str = getErrorStr(error)
            dispatch(requestFail(str))
        }
        setLoading(false)
    }
    
    // 分页
    const onPaginationChange: PaginationProps['onChange'] = (pageNumber: number): void => {
        if (pageSizeChanged.current) return
        getList({
            ...paginationInfo,
            pageIndex: pageNumber
        })
    }
    const onPageSizeChange = (current: number, size: number) => {
        // 避免重复触发 pageChange 事件
        pageSizeChanged.current = true
        getList({
            ...paginationInfo,
            pageIndex: current,
            pageSize: size
        })

        setTimeout(() => {
            pageSizeChanged.current = false
        }, 100)
    }

    const routes = [
        {
            path: '/indexPage',
            breadcrumbName: t('indexPage'),
        },
        {
            path: '/',
            breadcrumbName: t('Tech Change Status') + (i18n.language !== 'zh' ? ' ' : '') + t('list'),
        },
    ]

    useEffect(() => {
        getList(paginationInfo)

        const offsetW = 40
        const offsetH = 300
        setWinW(document.body.clientWidth - offsetW)
        setWinH(document.body.clientHeight - offsetH)
        const onResize = () => {
            setWinW(document.body.clientWidth - offsetW)
            setWinH(document.body.clientHeight - offsetH)
        }
        window.addEventListener('resize', onResize)
        return () => {
            window.removeEventListener('resize', onResize)
        }
    }, [])
    return (
        <Space direction="vertical" size={10}>
            <Nav dispatch={dispatch} />
            <PageBreadcrumb routerParam={routes}
                history={history}
                route={route}
                dispatch={dispatch}
            />
            <Space direction="vertical" size={20} style={{ margin: '0 10px' }}>
                {/* <Button type='primary'
                    icon={<PlusOutlined />}
                    onClick={() => {
                        history.push('/techChangeStatus')
                    }}
                >{t('add')}</Button> */}
                <div style={{ width: winW }}>
                    <Table rowKey='id' bordered
                        columns={columns} dataSource={dataSource}
                        loading={loading}
                        tableLayout='fixed'
                        scroll={{ x: 'max-content', y: winH }}
                        pagination={{
                            current: paginationInfo.pageIndex,
                            pageSize: paginationInfo.pageSize,
                            total: paginationInfo.total,
                            showQuickJumper: true,
                            onChange: onPaginationChange,
                            showSizeChanger: true,
                            onShowSizeChange: onPageSizeChange,
                            showTotal: (total) => 
                                `${t('total')} ${total} ${t('items')}`
                        }}
                    />
                </div>
            </Space>
        </Space>
    )
}

export default TechChangeList
